// extracted by mini-css-extract-plugin
module.exports = {"container":"RegenerateCollageMobile_container__3D7o6","answerClassName":"RegenerateCollageMobile_answerClassName__13roU"};